import script from "./create.vue?vue&type=script&setup=true&lang=js"
export * from "./create.vue?vue&type=script&setup=true&lang=js"

import "./create.vue?vue&type=style&index=0&id=5861f6b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5861f6b5"]])

export default __exports__